<template>
  <div class="end">
    <el-footer class="footer">
      <div class="footer-content">
        <p>&copy; 2025 某某大学. 版权所有.</p>
        <p>地址: 某某市某某路123号 | 电话: 123-456-7890</p>
        <p>邮箱: info@university.edu</p>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.end {
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 200px;
  background-color: #9e9a9a;
}
.footer {
  color: #333;
  text-align: center;
  padding: 20px 0;
  margin-top: 20px;
  border-top: 1px solid #e4e4e4;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer p {
  margin: 5px 0;
}
</style>
